var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "persona-aviso" }, [
    _c("div", { staticClass: "d-flex align-center", class: _vm.classeLinha }, [
      _c(
        "span",
        {
          staticClass:
            "persona-aviso__texto az-text-secondary az-muted ia-texto-auxiliar"
        },
        [_vm._v(_vm._s(_vm.texto))]
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }